import { render, staticRenderFns } from "./DiscountCodesEdit.vue?vue&type=template&id=62ffbbf0"
import script from "./DiscountCodesEdit.vue?vue&type=script&lang=ts"
export * from "./DiscountCodesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports